export default "__VITE_ASSET__Dc2i8Zor__"